import { create } from 'apisauce';

const apiUrl = {
  hml: 'http://localhost:3000/api/v1',
  prod: 'https://backend.postosgo.com.br/api/v1',
};

const api = create({
  baseURL: process.env.NODE_ENV === 'production' ? apiUrl.prod : apiUrl.hml,
  timeout: 25000,
  headers: {
    Authorization: '',
  },
});

export default api;
